import { createContext, useContext } from 'react';
import { GET_CATEGORIES_KEY, GET_MODELS_KEY } from 'src/graphql/models/query';
import { Category, BaseModel } from 'src/types/model.types';


export type BaseLayoutDataType = {
    [GET_MODELS_KEY]: Array<BaseModel>;
    [GET_CATEGORIES_KEY]: Array<Category>;
}

export const AppmodelSidebarStateContext = createContext({} as BaseLayoutDataType);



interface Props {
    children: React.ReactNode;
    data: BaseLayoutDataType;
}

export default function AppmodelSidebarProvider({ children, data }: Props) {
    return <AppmodelSidebarStateContext.Provider value={data}>{children}</AppmodelSidebarStateContext.Provider>;
}

export const useAppmodelSidebarData = () => {
    const data = useContext(AppmodelSidebarStateContext);
    if (!data) {
        throw new Error('you should use context inside provider');
    }

    return data;
};
